exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row-not-compliant {\n  color: red !important;\n  font-weight: bold;\n}\n", ""]);

// exports
